import { motion } from "framer-motion"
import { Lightbulb, X } from "lucide-react"

interface OnboardingTipProps {
  message: string
  onDismiss: () => void
  actionLabel?: string
  onAction?: () => void
}

export function OnboardingTip({ message, onDismiss, actionLabel, onAction }: OnboardingTipProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      className="mx-4 mb-4 relative z-10"
    >
      <div
        className="rounded-2xl px-4 py-3.5 flex items-start gap-3"
        style={{ background: "rgba(17,24,39,0.70)", border: "1px solid rgba(55,65,81,0.60)" }}
      >
        <div
          className="w-8 h-8 rounded-xl flex items-center justify-center shrink-0 mt-0.5"
          style={{ background: "rgba(6,182,212,0.12)", border: "1px solid rgba(6,182,212,0.20)" }}
        >
          <Lightbulb className="w-4 h-4" style={{ color: "#06b6d4" }} />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-[13px] text-white leading-relaxed">{message}</p>
          {actionLabel && onAction && (
            <button
              onClick={() => { onAction(); onDismiss() }}
              className="mt-2 text-[12px] font-semibold text-cyan-400 cursor-pointer hover:text-cyan-300 transition-colors"
            >
              {actionLabel} →
            </button>
          )}
        </div>
        <button
          onClick={onDismiss}
          aria-label="Fermer l'astuce"
          // Cible de 44 px (règle tactile) sans agrandir l'icône : la marge négative
          // garde la croix à sa place visuelle.
          className="shrink-0 -mt-2.5 -mr-2.5 w-11 h-11 flex items-center justify-center cursor-pointer text-gray-500 hover:text-gray-300 transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </motion.div>
  )
}
